import React from "react";
import { BsFillPhoneFill, BsGithub, BsLinkedin } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import ContactModal from "./ContactModal";

const Contacts = () => {
  return (
    <div className="mt-10" id="contacts">
      <label
        htmlFor="my-modal"
        className="btn btn-secondary text-xl font-bold mb-10"
      >
        Contact Me
      </label>
      {/* <button className="btn btn-secondary text-xl font-bold mb-10">
        Contact Me
      </button> */}
      <footer className="footer items-center p-4 text-neutral-content">
        <div className="items-center grid-flow-col">
          <h2 className="text-2xl font-bold">Shahinul Islam</h2>
        </div>
        <div className="grid-flow-col gap-4 md:place-self-center md:justify-self-end">
          <a href="tel:+8801737437378" target="_blank" className="flex">
            <BsFillPhoneFill className="h-6 w-6 mr-2"></BsFillPhoneFill>
          </a>
          <a href="mailto:shahinul.dev@gmail.com" className="flex items-center">
            <MdEmail className="h-6 w-6 mr-2"></MdEmail>
          </a>
          <a
            className="flex items-center"
            href="https://github.com/Shahinul-Islam"
            target="_blank"
          >
            <BsGithub className="h-6 w-6"></BsGithub>
          </a>
          <a
            className="flex items-center"
            href="https://www.linkedin.com/in/shahinul-islam-824aa1153/"
            target="_blank"
          >
            <BsLinkedin className="h-6 w-6"></BsLinkedin>
          </a>
        </div>
        <ContactModal></ContactModal>
      </footer>
    </div>
  );
};

export default Contacts;
